/**
 * Scripting for Search Results page.
 */

/**
 * On the Search Results page, show or hide remaining search results
 * when the "Show More" or "Show Less" buttons are clicked.
 */
jQuery(function($) {
  'use strict';

  /**
   * Shows all the search results for this block.
   *
   * @param JQuery $block   Search results block.
   */
  function show($block) {
    $block.find('.search-results-item.hidden').removeClass('hidden');

    // Hide the "Show More" button. Show the "Show Less" button.
    $block.find('.search-results-more').addClass('hidden');
    $block.find('.search-results-less').removeClass('hidden');
  }

  /**
   * Hides all the search results for this block.
   *
   * @param JQuery $block   Search results block.
   */
  function hide($block) {
    $block.find('.search-results-item:not(.show)').addClass('hidden');

    // Show the "Show More" button. Hide the "Show Less" button.
    $block.find('.search-results-less').addClass('hidden');
    $block.find('.search-results-more').removeClass('hidden');
  }

  /**
   * Initialize the project archive block.
   */
  function init() {
      /*
       * Show more search results if the "Show More" button is clicked.
       */
      $('.search-results-more-btn').on('click', function() {
        let $moreBtn = $(this);
        let $block = $moreBtn.closest('.search-results-block');

        show($block);
      });

      /*
       * Show more search results if the "Show More" button is clicked.
       */
      $('.search-results-less-btn').on('click', function() {
        let $moreBtn = $(this);
        let $block = $moreBtn.closest('.search-results-block');

        hide($block);
      });
  }

  init();
});

/**
 * Add behavior to the search results block selection buttons on the
 * top of the Search Results page.
 */
jQuery(function($) {
  'use strict';

  /**
   * Show the search results for the block with the given blockID.
   *
   * @param {JQuery} $searchResultsBlocks
   * @param {JQuery} $buttons
   * @param string blockId
   */
  function showSearchResult($searchResultsBlocks, $buttons, blockId) {
    // Highlight the selected button.
    $buttons
      .removeClass('active')
      .filter('[data-block-id="' + blockId + '"]').addClass('active');

    // Show all search results if the "All" button is clicked.
    if (blockId === 'search-results-all') {
      $searchResultsBlocks.removeClass('hidden');
      return;
    }

    // Show the selected block.
    $searchResultsBlocks
      .addClass('hidden')
      .filter('#' + blockId).removeClass('hidden');
  }

  /**
   * Show the filter buttons at the top of the search results listings.
   *
   * @param {JQuery} $searchResultsBlocks
   */
  function showButtons($searchResultsBlocks) {
    let $buttons = $('.search-results-toggle-btn');

    // Show the 'All' button.
    $buttons.filter('[data-block-id="search-results-all"]').removeClass('hidden');

    // Show the buttons for each displayed block.
    $searchResultsBlocks.each(function() {
      $buttons.filter('[data-block-id="' + $(this).attr('id') + '"]').removeClass('hidden');
    });

    // Handle button clicks.
    $buttons.on('click', function() {
      showSearchResult($searchResultsBlocks, $buttons, $(this).attr('data-block-id'));
    });
  }

  /**
   * Display the number of search results found.
   *
   * @param {JQuery} $searchResultsBlocks
   */
  function showSearchResultCount($searchResultsBlocks) {
    $('#search-results-count')
      .text($searchResultsBlocks.find('.search-results-item').length + ' Results');
  }

  /**
   * Show the Search Results listings.
   *
   * @param {JQuery} $searchResultsBlocks
   */
  function showSearchResultsFound($searchResultsBlocks) {
    showButtons($searchResultsBlocks);
    showSearchResultCount($searchResultsBlocks);
  }

  /**
   * Show the "No results found" message.
   * This message is only shown if the search input is not empty, indicating
   * a search was performed. We don't do anything for empty search terms.
   */
  function showSearchResultsNotFound() {
    $('.search-results-found').addClass('hidden');

    // Show the "No results found" message only if the search input is not empty.
    // Be sure we're grabbing the input value from the search form on the page and
    // not the header navigation side panel or mobile menu.
    let $searchInputValue = $('.search-results-form-input-field', 'main').first().val().trim();

    if ($searchInputValue.length) {
      $('.search-results-not-found').removeClass('hidden');
    }
  }

  /**
   * Show the Search Results section only if there are search results.
   * Otherwise, show the "No results found" message.
   */
  function init() {
    let $searchResultsBlocks = $('.search-results-block');

    $searchResultsBlocks.length
      ? showSearchResultsFound($searchResultsBlocks)
      : showSearchResultsNotFound();
  }

  init();
});



// WEBPACK FOOTER //
// ./scripts/search-results.js